import { FunctionComponent, useEffect } from 'react'
import config from '@config'
import { useQueryClient } from 'react-query'
import { getLocalStorageItem, setLocalStorageItem } from '@utils/localStorage'

const {
  ads: {
    admeira: { storageKey: admeiraStorageKey },
  },
  auth: { authURL, metadataPath },
} = config

interface AuthProps {}

const fetchAuthData = async () => {
  try {
    const result = await fetch(`${authURL}${metadataPath}`, {
      credentials: 'include',
    })

    const userMetadata = (await result.json())?.metadata

    if (!!userMetadata?.admeira_id) {
      setLocalStorageItem(admeiraStorageKey, {
        ...getLocalStorageItem<{ admeiraId: string }>(admeiraStorageKey),
        admeiraId: userMetadata.admeira_id,
      })
    }

    return userMetadata
  } catch (err) {
    return
  }
}

const Auth: FunctionComponent<AuthProps> = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    Promise.allSettled([
      queryClient.prefetchQuery('user', fetchAuthData),
      queryClient.prefetchQuery('auth-resolved', async () => true),
    ]).then(() => {
      queryClient.invalidateQueries('auth-resolved')
      queryClient.invalidateQueries('user')
    })
  }, [queryClient])

  return null
}

export default Auth
